import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/es";
import "./App.css";
import { AuthProvider } from "./app/providers/AuthProvider";
import { TenantProvider } from "./app/providers/TenantProvider";
import { PlanGateProvider } from "./app/providers/PlanGateProvider";
import { AppLayout } from "./app/layout";
import { AppRouter } from "./app/router/AppRouter";
import { RouteErrorBoundary } from "./app/router/RouteErrorBoundary";

// La app es en español (academias en Colombia): fechas en español en toda la app
// y en el calendario (react-big-calendar usa el locale global de dayjs).
dayjs.locale("es");

/**
 * App — root component.
 *
 * Provider tree (outermost → innermost):
 *   QueryClientProvider (in index.js)
 *     └─ BrowserRouter (in index.js)
 *          └─ AuthProvider   — session + token management
 *               └─ TenantProvider — slug → branding
 *                    └─ PlanGateProvider — 402 upgrade nudge (TASK-18/19)
 *                         └─ AppLayout — vertical-fixed shell (TASK-03)
 *                              └─ AppRouter — reads route-registry (R6)
 *
 * To add routes: create src/features/<name>/routes.js and call
 *   registry.register(yourRoutes)  in src/app/router/AppRouter.js.
 * Do NOT add routes here directly.
 */
function App() {
  return (
    <AuthProvider>
      <TenantProvider>
        <PlanGateProvider>
          <AppLayout>
            <RouteErrorBoundary>
              <AppRouter />
            </RouteErrorBoundary>
          </AppLayout>
        </PlanGateProvider>
      </TenantProvider>
    </AuthProvider>
  );
}

export default App;
